import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { t } from '../utils'
const PaymentSuccess = () => {
    return (
        <Alert severity="success" style={{ margin: '250px auto', width: '500px', }}>{t('payment.success')}</Alert>
    )
}
export default PaymentSuccess